import { ClassificationType, type ClassificationBasicItem, type ClassificationPagination } from '@/types/classification.ts';

export interface ApiClassificationHelperSubclassRequest {
    type: ClassificationType;
    code: string;
    start: number;
    level: number;
}

export interface ApiClassificationHelperSubclassResponse {
    response: ClassificationBasicItem[];
    responseHeader: ClassificationPagination;
}

export const ClassificationHelperSubclass = Symbol.for('ClassificationHelperSubclass');

export interface ClassificationHelperSubclass {
    classificationHelperSubclass(data: ApiClassificationHelperSubclassRequest): Promise<ApiClassificationHelperSubclassResponse>;
}
